











































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getDropdown, trackSubmit } from '@/api/track/index'
import { AppModule } from '@/store/modules/app'
import {
  getCountry,
  getShippingLists
} from '@/api/prescription'
@Component({
  name: 'create',
  components: {

  }
})
export default class extends Vue {
  get lang() {
    return AppModule.language.toString()
  }

  @Prop({ required: true }) private visible!: string
  @Prop({ required: true }) private detail!: any

  private form = {
    ship_type: '',
    country_id: '',
    order_type: '',
    nodeType: '1',
    tsc_rules: []
  }

  @Watch('detail', { deep: true, immediate: true })
  private onWatchChange() {
    if (this.detail) {
      this.form.ship_type = this.detail.ship_type
      this.form.country_id = this.detail.country_id
      this.form.tsc_rules = this.detail.tsc_rules.split(',')
      this.form.order_type = this.detail.order_type
      if (!this.detail.tsc_rules) {
        this.form.nodeType = '2'
      } else {
        this.form.nodeType = '1'
      }
    }
  }

  private rules = {
    ship_type: [
      { required: true, message: '请选择渠道代码', trigger: 'change' }
    ],
    country_id: [
      { required: true, message: '请选择国家', trigger: 'change' }
    ],
    tsc_rules: [
      {
        required: true,
        validator: (rule:any, value:any, callback:any) => {
          const nodeType = this.form.nodeType
          console.log('nodeType', nodeType)
          if (nodeType === '1' && value.length === 0) {
            callback(new Error('请选择订阅节点'))
          } else {
            callback()
          }
        },
        trigger: 'change'
      }
    ]
  }

  // public nodeType:any = '1'
  public tscRulesList:any = []
  public countryList:any = [];
  public shippingList:any = [];
  public orderType:any = [
    {
      key: 1, label: 'AE单号', value: 'ae_code'
    },
    {
      key: 2, label: '跟踪号', value: 'tracking_number'
    }
  ]

  public getShippingLists() {
    const obj = {}
    getShippingLists(obj).then((res) => {
      this.shippingList = res.data
    })
  }

  public getCountry() {
    const obj = {}

    getCountry(obj).then((res) => {
      this.countryList = res.data
    })
  }

  public handleNodeTypeChange(val:any) {
    (this.$refs.ruleForm as any).clearValidate()
    this.form.nodeType = val
  }

  public handleCancel() {
    this.$emit('close')
  }

  public handleConfirm() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        const obj = {
          tsc_id: this.detail ? this.detail.tsc_id : undefined,
          ship_type: this.form.ship_type,
          country_id: this.form.country_id,
          tsc_type: '1',
          tsc_rules: this.form.nodeType === '1' ? this.form.tsc_rules.join(',') : '',
          order_type: this.form.order_type
        }
        trackSubmit(obj).then(() => {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.$emit('close')
        })
      } else {
        return false
      }
    })
  }

  public handleGetDropdown() {
    getDropdown({
      type: ['tsc_rules']
    }).then((res) => {
      this.tscRulesList = Object.entries(res.data.tsc_rules).map(([key, value]) => ({ key: String(key), value }))
      // console.log('this.tscRulesList', this.tscRulesList)
    })
  }

  created() {
    this.getShippingLists()
    this.getCountry()
    this.handleGetDropdown()
  }

  handleClose() {
    this.$emit('close')
  }
}
